import React from "react";
import HOC from "../../components/HOC";
import OnlineBilling from "../../components/screen/billing/OnlineBilling";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import BillingBreadcrumb from "../../components/screen/billing/BillingBreadcrumb";

const OnlineBillingPage = ({ isPbf }) => {
  return (
    <div className="">
      <PageTemplate
        header={`Billing Online ${isPbf ? "PBF" : ""}`}
        mainComponent={
          <ThemeProvider theme={theme}>
            <OnlineBilling isPbf={isPbf ? isPbf : false} />
          </ThemeProvider>
        }
        pageRole={7}
        breadcrumb={<BillingBreadcrumb />}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(OnlineBillingPage);
